import {
  Box,
  ListItem,
  ListItemIcon,
  Menu,
  MenuItem,
  Popover,
  Typography,
} from "@mui/material";
import WPSelectLabel from "components/SelectLabel";
import { apiService } from "constants/axiosInstance";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import {
  DEFAULT_MESSAGE,
  SnackbarEmitter,
  SNACKBAR_VARIANT,
} from "constants/snackbarController";
import { get } from "lodash";
import ManagerLabelModal from "views/ProjectGroupPage/Modals/ManagerLabel";
import { useDispatch, useSelector } from "react-redux";
import { listProjectLabel } from "actions/projectLabels/listProjectLabels";

const LabelList = ({ project }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openManagerLabelModal, setOpenManagerLabelModal] = useState(false);
  const [data, setData] = React.useState([]);
  const { t } = useTranslation();
  const [selected, setSelected] = React.useState(
    project?.project_label ?? undefined
  );
  const dispatch = useDispatch();
  const labelsProject = useSelector(
    ({ projectLabels }) => projectLabels.listProjectLabels
  );

  useEffect(() => {
    if (labelsProject.firstTime) dispatch(listProjectLabel());
  }, []);

  const [hovering, setHovering] = useState(false);
  // const refOptions = React.useRef(null);

  useEffect(() => {
    setSelected(project?.project_label ?? undefined);
  }, [project]);

  // React.useEffect(() => {
  //   const _getData = async () => {
  //     const result = await apiService({ url: "/project-label/list" });
  //     setData(result.data.labels);
  //   };

  //   _getData();
  // }, []);

  console.log(data, project, "data label");

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUpdateProject = async (data) => {
    try {
      await apiService({
        url: "/project/update-label",
        method: "PUT",
        data,
      }).then((res) => {
        console.log(res);
      });
      SnackbarEmitter(SNACKBAR_VARIANT.SUCCESS, DEFAULT_MESSAGE.MUTATE.SUCCESS);
    } catch (error) {
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(error, "messaage", DEFAULT_MESSAGE.MUTATE.ERROR)
      );
    }
  };

  const handleSelect = async (item) => {
    await handleUpdateProject({
      project_id: project?.id,
      project_label_id: item?.id || null,
    });
    setSelected(item);
    setHovering(false);
  };

  return (
    <div
      onMouseEnter={() => {
        setHovering(true);
      }}
      onMouseLeave={() => {
        setHovering(false);
      }}
    >
      {!selected || hovering ? (
        <Box
          sx={{
            background: "white",
            border: "1px solid rgb(230, 230, 230)",
            padding: "5px 10px",
            borderRadius: "15px",
            color: "black",
            maxWidth: "100%",
            width: "max-content",
            fontWeight: "normal",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "14px",
            cursor: "pointer",
          }}
          onClick={handleClick}
        >
          + {t("LABEL_CATEGORY")}
        </Box>
      ) : (
        <Box
          sx={{
            padding: "5px 10px",
            borderRadius: "15px",
            color: "#fff",
            maxWidth: "100%",
            width: "max-content",
            fontWeight: "normal",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "14px",
            background: selected?.color,
            cursor: "pointer",
          }}
          onClick={handleClick}
        >
          {selected?.name}
        </Box>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          key={""}
          sx={{
            width: "200px",
            "&:hover": {
              background: "#f2f5fa !important",
            },
          }}
          onClick={() => handleSelect(null)}
        >
          <div style={{ width: 38 }} /> -
        </MenuItem>
        {labelsProject.data?.projectLabels?.map((item, index) => (
          <MenuItem
            key={index}
            sx={{
              width: "200px",
              "&:hover": {
                background: "#f2f5fa !important",
              },
            }}
            onClick={() => handleSelect(item)}
          >
            <DoneIcon
              style={{
                marginRight: 10,
                color: "#666",
                visibility: selected?.id === item.id ? "visible" : "hidden",
              }}
            />
            <Typography
              style={{
                background: item.color,
                padding: "5px 15px",
                borderRadius: "15px",
                color: "#fff",
                fontSize: "12px",
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
              nowrap
            >
              {item.name}
            </Typography>
          </MenuItem>
        ))}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "#666",
            borderTop: "1px solid #e8ecee",
          }}
        >
          <ListItem
            onClick={() => {
              setOpenManagerLabelModal(true);
            }}
          >
            <ListItemIcon style={{ minWidth: 20 }}>
              <EditIcon />
            </ListItemIcon>
            <span style={{ marginLeft: "5px" }}>Chỉnh sửa</span>
          </ListItem>
        </div>
      </Menu>
      <ManagerLabelModal
        open={openManagerLabelModal}
        setOpen={setOpenManagerLabelModal}
        isProjectGroupPage={false}
        curProject={project}
        handleRemove={(lableRemoved) => {
          if (selected?.id === lableRemoved?.id) setSelected(undefined);
        }}
        handleUpdate={(lableUpdated) => {
          if (selected?.id === lableUpdated?.id) setSelected(lableUpdated);
        }}
      />
    </div>
  );
};

export default LabelList;
